import React, { useContext } from 'react';
import BookmarkContext from './context/BookmarkContext';
import Loading from './Loading';

const Card = () => {
  const { handleUpdate, handleDelete, filteredBookmarks, loading } = useContext(BookmarkContext);

  return (
    <>
      {
        loading ? <Loading /> :
          filteredBookmarks.length === 0 ?
            <div className='d-flex justify-content-center fw-bolder' style={{ height: "75vh" }}>
              <b className='d-flex align-items-center fs-4'>No Bookmark Found</b>
            </div> :
            filteredBookmarks.map((item, index) => (
              <div className='col-md-3 col-6 my-3 bookmark-1' key={index}>
                <div className="card mb-4 shadow-lg border-2 rounded-4 custom-card">
                  <div className="d-flex align-items-center position-relative p-3">
                    {/* Logo Section */}
                    <div className='d-flex justify-content-between w-100 card-2'>
                      <div className="logo-container me-3 card-3 bg-transparent">
                        <img src={item.logo} className="img-fluid rounded logo-img" alt={item.webname} />
                      </div>

                      {/* Content Section */}
                      <div className="flex-grow-1 mt-2 text-center">
                        <h5 className="mb-2 fw-semibold">{item.webname}</h5>
                        <a
                          className="btn btn-outline-primary btn-sm w-100"
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit Site
                        </a>
                      </div>
                    </div>

                    {/* Icon Actions */}

                    <div className="icon-actions position-absolute top-0 end-0 p-2 d-flex gap-3">
                      <i className="fa-solid fa-file-pen text-primary cursor-pointer" onClick={() => handleUpdate(item._id, item.logo, item.webname, item.url)}></i>
                      <i className="fa-solid fa-trash-can text-danger cursor-pointer" onClick={() => handleDelete(item._id, item.webname)}></i>
                    </div>

                  </div>
                </div >
              </div>
            ))
      }
    </>
  );
};

export default Card;
